import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

interface ChannelItem {
  id: string;
  nome: string;
  canal: string;
  ultimoTexto: string;
  atualizadoEm: string;
  unreadCount?: number;
}

const channels = ['TODOS', 'APP', 'PUSH', 'EMAIL', 'WHATSAPP', 'SMS', 'FORMULARIO'];

export function ChatOmnichannelInbox() {
  const [channel, setChannel] = useState('TODOS');
  const [items, setItems] = useState<ChannelItem[]>([]);

  useEffect(() => {
    api.get('/chat-interno/omnichannel/inbox', { params: { canal: channel } })
      .then((res) => setItems(res.data || []));
  }, [channel]);

  return (
    <div className="ac-chat-v8-panel">
      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Inbox omnichannel</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
          {channels.map((item) => (
            <button key={item} className={`ac-chat-filter-chip ${channel === item ? 'is-active' : ''}`} onClick={() => setChannel(item)}>{item}</button>
          ))}
        </div>
      </div>

      {items.map((item) => (
        <div key={item.id} className="ac-chat-v8-card">
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
            <strong>{item.nome}</strong>
            <span className="ac-chat-channel-pill">{item.canal}</span>
          </div>
          <p className="ac-chat-automation-text" style={{ marginTop: 8 }}>{item.ultimoTexto}</p>
        </div>
      ))}
    </div>
  );
}
